import React from 'react'
import styled from 'styled-components'

const Fondo = ({ children }) => {
    return (
        <Container>
            {children}
        </Container>
    )
}

const Container = styled.div`
    top: 0;
    z-index: 6;
    width: 100vw;
    height: 100vh;
    position: fixed;
    background-color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
`

export default Fondo